import { async } from "@firebase/util";
import axios from "../../utils/axios";

import { ADDVENDOR, GETVENDOR, UPDATEVENDOR } from "../../utils/api";

export const addVendor = async (payload) => {
  const res = await axios.post(ADDVENDOR, payload);
  return res;
};

export const updateVendor = async (payload) => {
  const res = await axios.post(UPDATEVENDOR, payload);
  return res;
};

export const getVendors = async () => {
  const res = await axios.get(GETVENDOR);
  return res;
};
